import request from '@/utils/request'

export const getWarehouses = params => request.get('/accounting/warehouses', { params })

export const createWarehouse = data => request.post('/accounting/warehouses', data)

export const getWarehouse = id => request.get(`/accounting/warehouses/${id}`)

export const updateWarehouse = (id, data) => request.put(`/accounting/warehouses/${id}`, data)
